
$(document).ready(() => {

    if (!$.connection || !$.connection.controleSessoesAplicativoAbertasHub) {
        // Esperado em paginas sem sessao autenticada (ex: Login), que nao carregam /signalr/hubs
        console.warn('controleSessoesAplicativoAbertasHub => proxy do hub nao encontrado (verifique se /signalr/hubs foi carregado)')
        return
    }

    $.connection.hub.qs = {
        'sessaoAplicativo': (window as any).oidSessaoAplicativo
    }

    $.connection.controleSessoesAplicativoAbertasHub.client.pong = () => {
        console.log('controleSessoesAplicativoAbertasHub => pong')
    }
    
    $.connection.hub.start().done(() => {
        console.log('controleSessoesAplicativoAbertasHub => connected, conection id =',$.connection.hub.id)

        $.connection.controleSessoesAplicativoAbertasHub.server.ping()


    }).fail(() => console.error('connect fail'))

    window.addEventListener('load', function() {

        // Verifica se o site já está aberto em outra aba
        //const isSiteOpen = sessionStorage.getItem('orcamentoWebAberto');
        const isSiteOpen = false
        if (isSiteOpen) {
            window.alert('O VENDAS já está aberto em outra aba!\n\nNão é possível abrir mais VENDAS no mesmo navegador.\n\nUse modo anônimo ou outro navegador para abrir outra sessão do VENDAS.');
            window.location.href = "about:blank"
            window.close(); // "tenta" Fechar a aba atual (browser nao deixam mais fechar abas via script)
            return false
        } else {
            sessionStorage.setItem('orcamentoWebAberto', "true");  // Marca que a aba está aberta

            // Remove o item do sessionStorage quando a aba é fechada
            window.addEventListener('beforeunload', function() {
                sessionStorage.removeItem('orcamentoWebAberto');
            });
        }
    });

})